import { defineComponent as _defineComponent } from 'vue'
import { useToastStore } from '@modules/shared/stores/toast'
import ToastItem from './ToastItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props, { expose: __expose }) {
  __expose();

const toast = useToastStore()

const __returned__ = { toast, ToastItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})